namespace advisorop.components.widgets {
    
    export class GaugeRiskMonitorController{
        chartData: Array<domains.IChartDataSource>;
        asOfDate;
        riskValue;
        rtgName: string;    
        gauge;
        warningLabel: string;
        rtgExt: domains.IAccountGroup;
        rtqType: string;
        toleranceType: string;
        dateDesc: Date;

        getRtName(): string {
            if (this.rtgExt && this.rtgExt.rtq && this.rtgExt.rtq.riskTolerance)
                return this.rtgExt.rtq.riskTolerance.name;
            else {
                //console.log("Warning, RTG name taken from description!")
                return this.rtgName;
            }
        }

        isRtDiffer(): boolean {

            var equity = "Conservative";
            if (this.riskValue > 30 && this.riskValue <= 50) {
                equity = "Balanced";
            }
            else if (this.riskValue > 50 && this.riskValue <= 70) {
                equity = "Growth";
            }
            else if (this.riskValue > 70) {
                equity = "Aggressive";
            }

            //console.log("isRtDiffer: Equity=", equity, "rtgName=", this.rtgName, "riskValue=", this.riskValue, this.rtgExt);

            var rt = this.getRtName();
            //console.log("RT=", rt);
            
            return rt && !(rt.indexOf(equity) >= 0);
        }

        getSegmentColors(): any {

            var colors = [
                {
                    "code":"",
                    "minValue": "0",
                    "maxValue": "30",
                    "label": "Conservative",
                },
                {
                    "code": "",
                    "minValue": "30",
                    "maxValue": "50",
                    "label": "Balanced",
                }, {
                    "code": "",
                    "minValue": "50",
                    "maxValue": "70",
                    "label": "Growth",
                }, {
                    "code": "",
                    "minValue": "70",
                    "maxValue": "100",
                    "label": "Aggressive",
                }];

            var rt = this.getRtName();
            //console.log("RT 2=", rt);
            if (rt /*&& this.isRtDiffer()*/)
            {
                colors[0].code = (rt.indexOf("Conservative") >= 0) ? "#63af33" : "#ff1919";
                colors[1].code = (rt.indexOf("Balanced") >= 0) ? "#63af33" : "#ff1919";
                colors[2].code = (rt.indexOf("Growth") >= 0) ? "#63af33" :"#ff1919";
                colors[3].code = (rt.indexOf("Aggressive") >= 0) ? "#63af33" :"#ff1919";                
            }

            return colors;      
        }

        updateGauge() {

            var pointer = {
                "bgColor": "#0c9b43",
                "radius": "10",
                "sides": "3",
                "value": this.riskValue,
                "displayValue": "{br}Core Portfolio is {br}" + this.riskValue + "% Equities"
            };

            if (this.isRtDiffer()) {
                pointer.bgColor = "#b70e0e";
                this.warningLabel = "WARNING: OUT OF COMPLIANCE";
            }
            else {
                this.warningLabel = "";
            }

            //setting points

            /*
            green #63af33
            orange #ffa500
            red #cc0000

            */
            this.gauge = {
                "chart": {
                    "theme": "fint",
                    "baseFontSize":"14",
                    //"caption": "Portfolio Equity Allocation",
                    //"subcaption": "RTG: " + this.rtgName,
                    "lowerLimit": "0",
                    "upperLimit": "100",
                    "numberSuffix": "%",
                    "chartBottomMargin": "40",
                    "valueFontSize": "13",
                    "valueFontBold": "0",
                    "valueAbovePointer": "0",
                    "gaugeFillMix": "{light-10},{light-70},{dark-10}",
                    "gaugeFillRatio": "40,20,40",
                    "showTickMarks": "0",
                    "showTickValues": "0",
                    "pointerOnTop": "0"
                },
                "colorRange": {
                    "color": this.getSegmentColors()
                },
                "pointers": {
                    "pointer": [pointer]
                },
                "trendPoints": {
                    "point": [
                        //Adding Trendpoint
                        {
                            "startValue": "0",
                            "color": "#a0a0a0",
                            "dashed": "0",
                            "thickness": "2"
                        }, {
                            "startValue": "30",
                            "color": "#a0a0a0",
                            "dashed": "0",
                            "thickness": "2"
                        }, {
                            "startValue": "50",
                            "color": "#a0a0a0",
                            "dashed": "0",
                            "thickness": "2"
                        }, {
                            "startValue": "70",
                            "color": "#a0a0a0",
                            "dashed": "0",
                            "thickness": "2"
                        }, {
                            "startValue": "100",
                            "color": "#a0a0a0",
                            "dashed": "0",
                            "thickness": "2"
                        }, {
                            "startValue": this.riskValue,
                            "dashed": "1",
                            "thickness": "1",
                            "displayValue": " "
                        }
                    ]
                }
            };
        };    

        
        constructor(private advisorService: services.AdvisorService) {
                                
        }
      

        $onChanges(evt) {
            for (var key in evt) {
                if (key === "riskValue" && this.riskValue >= 0) {
                    //console.log("Updating gauge to:" + this.riskValue);
                    this.updateGauge();
                }
                if (key === "rtgExt" && this.rtgExt) {
                    this.rtqType = this.rtgExt.rtq.rtqTypeDescription;
                    this.toleranceType = this.rtgExt.rtq.riskTolerance.name;
                    this.dateDesc = this.rtgExt.rtq.questionnaireResult.dateStart;
                }
            }
        }

        $onInit(): void {
            if (this.riskValue == undefined) {
                this.riskValue = 0;
            }
            this.updateGauge();            
        }

        $routerOnActivate(next, previous) {
            
        }        

    }



    class GaugeRiskMonitor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.bindings = {
                riskValue: "<",
                rtgName: "<",
                rtgExt: "<"
            };
            this.controller = ["advisorService", GaugeRiskMonitorController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/gauge-risk-monitor.html';            
        }
    }
    angular.module(Constants.APP).component("gaugeRiskMonitor", new GaugeRiskMonitor());
    
}